module.exports = __webpack_public_path__ + "static/media/copy.5f230331.svg";